import { render, staticRenderFns } from "./IconEditPencil.vue?vue&type=template&id=23fe3e0a"
import script from "./IconEditPencil.vue?vue&type=script&lang=js"
export * from "./IconEditPencil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports